__turbopack_context__.v({
  "button": "text-image-block-module-scss-module__u1IQpW__button",
  "button1": "text-image-block-module-scss-module__u1IQpW__button1",
  "buttonSimple": "text-image-block-module-scss-module__u1IQpW__buttonSimple",
  "buttonSimple1": "text-image-block-module-scss-module__u1IQpW__buttonSimple1",
  "buttongroup": "text-image-block-module-scss-module__u1IQpW__buttongroup",
  "container": "text-image-block-module-scss-module__u1IQpW__container",
  "iconWrapper": "text-image-block-module-scss-module__u1IQpW__iconWrapper",
  "imageIcon": "text-image-block-module-scss-module__u1IQpW__imageIcon",
  "imageIcon1": "text-image-block-module-scss-module__u1IQpW__imageIcon1",
  "li": "text-image-block-module-scss-module__u1IQpW__li",
  "list": "text-image-block-module-scss-module__u1IQpW__list",
  "submitButtonLink": "text-image-block-module-scss-module__u1IQpW__submitButtonLink",
  "text": "text-image-block-module-scss-module__u1IQpW__text",
  "text1": "text-image-block-module-scss-module__u1IQpW__text1",
  "textimageblock": "text-image-block-module-scss-module__u1IQpW__textimageblock",
  "title": "text-image-block-module-scss-module__u1IQpW__title",
});
